"use client";

import Link from 'next/link';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function ErrorFallback() {
  return (
    <div className="container py-10">
      <div className="mb-8">
        <Button variant="outline" asChild>
          <Link href="/blog" className="inline-flex items-center">
            <ChevronLeft className="h-4 w-4 mr-2" />
            Back to all posts
          </Link>
        </Button>
      </div>
      
      <div className="p-8 text-center bg-red-50 dark:bg-red-900/20 rounded-lg">
        <h2 className="text-lg font-bold text-red-800 dark:text-red-300">We're sorry!</h2>
        <p className="mt-2 text-red-700 dark:text-red-200">
          There was an error loading this blog post. Please try refreshing the page or come back later.
        </p>
      </div>
    </div>
  );
}
